import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div')<{ size: number }>`
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ size }) => `
        width: ${size}px;
        height: ${size}px;
    `}
    background-color: ${COLORS['grey']};
    border-radius: 50%;
    flex-shrink: 0;
    overflow: hidden;
`;

export const Image = styled('img')`
    display: block;
    border: none;
    outline: none;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const IconWrapper = styled('div')`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;

    svg {
        width: 70%;
        height: 70%;
        color: ${COLORS.neutral_50};
    }
`;
